import { OptionModel } from "datahive-ngx-structure";
import { ServiceBookItemListResponse } from "src/app/core/output-data/service-book-item-list.response";

export class ServiceBookItemListViewModel {
   response: ServiceBookItemListResponse;
}
